var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Typography } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { checkDefaultTrackingTypeAPI, getAvailableQtyByWarehouseAPI, getProductPriceAPI, LocationByWarehouseList, ProductList, SerialNumberList } from '../../../api/url';
import { generateCodeName } from '../../../builderPackage/common/commonFunctions';
import { EditableDataGrid } from '../../../builderPackage/components/editableDataGrid/editableDataGrid';
import { MuiPopup } from '../../../components';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showNotification } from '../../../redux/commonSlice';
import { secondaryTextGray } from '../../../theme/palette';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { checkDefaultTrackingTypeAPIGet, getAvailableQtyByWarehouse, getProductPriceAPIGet, locationByWarehouseListGet, productListGet, serialNumberListGet } from '../apiCall';
import { StockTransferRequisitionAPIKeys } from '../entity';
import { MultiSelectPopUp } from './multiSelectPopUp';
import SourceLocationCell from './sourceLocationCell';
import { GoogleAnlyticsErrorLog } from '../../../utils/utils';
export default function StockAdjustmentRequistionPartDetails(props) {
    var _this = this;
    var _props$value, _getLocalStorageItem;
    var onChange = props.onChange, value = props.value, error = props.error;
    var warehouseId = props === null || props === void 0 || (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.SourceWarehouseId;
    var dispatch = useDispatch();
    var serialNumberKey = 'SerialNumberList_';
    var _a = useState(), modalProps = _a[0], setModalProps = _a[1];
    var _b = useState(false), sourceLocationPopup = _b[0], setSourceLocationPopup = _b[1];
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    useEffect(function () {
        productListGet({
            key: 'ProductListData',
            url: ProductList
        });
    }, []);
    useEffect(function () {
        if (warehouseId) {
            locationByWarehouseListGet({
                key: 'warehouseListData',
                request: {
                    WarehouseId: warehouseId
                },
                url: LocationByWarehouseList
            });
        }
    }, [warehouseId]);
    var sourceLocation = [{
            field: 'LocationName',
            headerName: 'Storage location ',
            editable: false,
            flex: 1,
            width: 300
        }, {
            field: 'QuantityAvailable',
            headerName: 'Available Qty',
            editable: false,
            flex: 1,
            width: 300
        }, {
            type: 'number',
            field: 'RequestedQuantity',
            headerName: 'Transfer Qty',
            editable: true,
            flex: 1,
            width: 300
        }];
    var destinationLocation = [{
            field: 'LocationName',
            headerName: 'Storage location ',
            editable: false,
            flex: 1,
            width: 300
        }, {
            field: 'QuantityAvailable',
            headerName: 'Available Qty',
            editable: false,
            flex: 1,
            width: 300
        }, {
            type: 'number',
            field: 'RequestedQuantity',
            headerName: 'Transfer Qty',
            editable: true,
            flex: 1,
            width: 300
        }];
    var handleCellEditStop = function (params, event, details) { return __awaiter(_this, void 0, void 0, function () {
        var row, field, rowData, _checkDefaultTracking, _checkDefaultTracking2, _checkDefaultTracking3, isDuplicateProduct, profileData, key, checkDefaultTrackingResponse, getProductResponse, getAvailableQtyResponse, updatedRows;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    row = details.api.getRowWithUpdatedValues(params.id, params.field);
                    field = params.field;
                    rowData = value.StockTransferRequisitionDetail;
                    if (!(field === 'Product' && row.ProductId)) return [3 /*break*/, 5];
                    isDuplicateProduct = rowData.some(function (r) { return r.ProductId === row.ProductId && r.id !== row.id; });
                    if (isDuplicateProduct) {
                        profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Product is already selected");
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Product is already selected",
                            type: "error"
                        }));
                        row.ProductId = undefined;
                        return [2 /*return*/];
                    }
                    key = serialNumberKey + row.ProductId;
                    return [4 /*yield*/, serialNumberListGet({
                            key: key,
                            request: {
                                ProductId: row.ProductId,
                                TenantId: UserOrganization
                            },
                            url: SerialNumberList
                        })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, checkDefaultTrackingTypeAPIGet({
                            key: "GetCheckDefaultTracking",
                            request: {
                                ProductId: row.ProductId
                            },
                            url: checkDefaultTrackingTypeAPI
                        })];
                case 2:
                    checkDefaultTrackingResponse = _a.sent();
                    row.UnitOfMeasurementId = checkDefaultTrackingResponse === null || checkDefaultTrackingResponse === void 0 || (_checkDefaultTracking = checkDefaultTrackingResponse.data) === null || _checkDefaultTracking === void 0 ? void 0 : _checkDefaultTracking.UnitOfMeasurementId;
                    row.UOM = checkDefaultTrackingResponse === null || checkDefaultTrackingResponse === void 0 || (_checkDefaultTracking2 = checkDefaultTrackingResponse.data) === null || _checkDefaultTracking2 === void 0 ? void 0 : _checkDefaultTracking2.UnitOfMeasurementName;
                    row.DefaultInventoryTrackingType = checkDefaultTrackingResponse === null || checkDefaultTrackingResponse === void 0 || (_checkDefaultTracking3 = checkDefaultTrackingResponse.data) === null || _checkDefaultTracking3 === void 0 ? void 0 : _checkDefaultTracking3.DefaultInventoryTrackingType;
                    return [4 /*yield*/, getProductPriceAPIGet({
                            key: "GetProduct",
                            request: {
                                ProductId: row.ProductId
                            },
                            url: getProductPriceAPI
                        })];
                case 3:
                    getProductResponse = _a.sent();
                    row.PurchasePrice = getProductResponse === null || getProductResponse === void 0 ? void 0 : getProductResponse.PurchaseBasePrice.Price;
                    row.MRP = getProductResponse === null || getProductResponse === void 0 ? void 0 : getProductResponse.SaleMRP.Price;
                    return [4 /*yield*/, getAvailableQtyByWarehouse({
                            key: "getTotalQuantity",
                            request: {
                                TenantId: UserOrganization,
                                ProductId: row.ProductId,
                                WarehouseId: warehouseId
                            },
                            url: getAvailableQtyByWarehouseAPI
                        })];
                case 4:
                    getAvailableQtyResponse = _a.sent();
                    row.AvailableQuantity = getAvailableQtyResponse === null || getAvailableQtyResponse === void 0 ? void 0 : getAvailableQtyResponse.TotalAvailableQuantity;
                    updatedRows = rowData === null || rowData === void 0 ? void 0 : rowData.map(function (r) { return r.id === row.id ? row : r; });
                    onChange(null, updatedRows);
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var columns = [{
            type: 'searchSelect',
            field: 'Product',
            headerName: 'Part name & code',
            editable: true,
            flex: 1,
            headerAlign: 'left',
            getOptionLabel: function (value) { return generateCodeName(value, 'SkuCode', 'Name'); },
            valueFormatter: function (value) { return value === null || value === void 0 ? void 0 : value.Name; },
            valueSetter: function (value, row) { return _objectSpread(_objectSpread({}, row), {}, {
                Product: value,
                ProductId: value === null || value === void 0 ? void 0 : value.ProductId,
                ProductName: value === null || value === void 0 ? void 0 : value.Name,
                ProductCode: value === null || value === void 0 ? void 0 : value.SkuCode
            }); },
            getListData: productListGet,
            apiKey: StockTransferRequisitionAPIKeys.stockTransferRequisitionPartList,
            placeholder: 'Enter Part,Code',
            moreButtonText: 'Search More...',
            minWidth: 200,
            renderCell: function (params) {
                var _params$row, _params$row2, _params$row3, _params$row4;
                if (!((_params$row = params.row) !== null && _params$row !== void 0 && _params$row.ProductName) && !((_params$row2 = params.row) !== null && _params$row2 !== void 0 && _params$row2.ProductCode)) {
                    return params.formattedValue;
                }
                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: "inherit"
                }, (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.ProductName), /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: "inherit",
                    color: secondaryTextGray
                }, "#".concat((_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.ProductCode)));
            }
        }, {
            field: 'UOM',
            headerName: 'UOM',
            editable: false,
            flex: 1,
            headerAlign: 'left'
        }, {
            type: 'number',
            field: 'AvailableQuantity',
            headerName: 'Available Qty',
            editable: false,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        }, {
            type: 'number',
            field: 'RequestedQuantity',
            headerName: 'Req. transfer qty',
            editable: true,
            flex: 1,
            headerAlign: 'left',
            align: 'left'
        }, {
            field: 'SourceLocations',
            headerName: 'Source location',
            editable: false,
            flex: 1,
            headerAlign: 'left',
            renderCell: function (params) {
                var _params$row9;
                var handleLocationDetailSubmit = function (selectedRows, rows, rowData) {
                    var _value$StockTransferR;
                    var filteredData = rows === null || rows === void 0 ? void 0 : rows.filter(function (item) { return selectedRows.includes(item === null || item === void 0 ? void 0 : item.id); });
                    var transformedData = filteredData === null || filteredData === void 0 ? void 0 : filteredData.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                        AvailableQuantity: item.QuantityAvailable
                    }); });
                    var newRows = (_value$StockTransferR = value.StockTransferRequisitionDetail) === null || _value$StockTransferR === void 0 ? void 0 : _value$StockTransferR.map(function (r) {
                        var _params$row5;
                        return (params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.id) === (r === null || r === void 0 ? void 0 : r.id) ? _objectSpread(_objectSpread({}, r), {}, {
                            SourceLocations: transformedData
                        }) : r;
                    });
                    if (onChange)
                        onChange(null, newRows);
                };
                var getSourceLocations = function (apiParams) { return __awaiter(_this, void 0, void 0, function () {
                    var _res$data, res, data;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getAvailableQtyByWarehouse(apiParams)];
                            case 1:
                                res = _a.sent();
                                data = res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.map(function (r) {
                                    var _params$row$SourceLoc, _params$row$SourceLoc2;
                                    return (_params$row$SourceLoc = (_params$row$SourceLoc2 = params.row.SourceLocations) === null || _params$row$SourceLoc2 === void 0 ? void 0 : _params$row$SourceLoc2.find(function (it) { return it.id === r.id; })) !== null && _params$row$SourceLoc !== void 0 ? _params$row$SourceLoc : r;
                                });
                                return [2 /*return*/, {
                                        data: data,
                                        success: true
                                    }];
                        }
                    });
                }); };
                var onsourceLocationClick = function () {
                    var _params$row6, _params$row7, _params$row8;
                    var modalProps = {
                        onSubmit: handleLocationDetailSubmit,
                        apiRequest: {
                            TenantId: UserOrganization,
                            ProductId: params === null || params === void 0 || (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.ProductId,
                            WarehouseId: warehouseId
                        },
                        apiCall: getSourceLocations,
                        apiKey: 'getAvailableQty',
                        columns: sourceLocation,
                        title: t('Source location'),
                        data: params === null || params === void 0 || (_params$row7 = params.row) === null || _params$row7 === void 0 ? void 0 : _params$row7.SourceLocations,
                        rowData: params.row,
                        formData: value,
                        selectedRows: (params === null || params === void 0 || (_params$row8 = params.row) === null || _params$row8 === void 0 || (_params$row8 = _params$row8.SourceLocations) === null || _params$row8 === void 0 ? void 0 : _params$row8.map(function (e) { return e === null || e === void 0 ? void 0 : e.id; })) || []
                    };
                    setModalProps(modalProps);
                    setSourceLocationPopup(true);
                };
                return /*#__PURE__*/ React.createElement(SourceLocationCell, _extends({}, params, {
                    onButtonClick: onsourceLocationClick,
                    rowData: params === null || params === void 0 || (_params$row9 = params.row) === null || _params$row9 === void 0 ? void 0 : _params$row9.SourceLocations,
                    formData: value
                }));
            }
        }, {
            field: 'DestinationLocationId',
            headerName: 'Destination location',
            editable: true,
            flex: 1,
            headerAlign: 'left',
            getOptionLabel: function (value) { return generateCodeName(value, 'Code', 'DisplayName'); },
            getOptionValue: function (value) { return value === null || value === void 0 ? void 0 : value.id; },
            valueSetter: function (value, row) {
                row.DestinationLocationId = value;
                return row;
            },
            renderCell: function (params) {
                var _params$row14;
                var handleLocationDetailSubmit = function (selectedRows, rows, rowData) {
                    var _value$StockTransferR2;
                    var filteredData = rows === null || rows === void 0 ? void 0 : rows.filter(function (item) { return selectedRows.includes(item === null || item === void 0 ? void 0 : item.id); });
                    var transformedData = filteredData === null || filteredData === void 0 ? void 0 : filteredData.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                        AvailableQuantity: item.QuantityAvailable
                    }); });
                    var newRows = (_value$StockTransferR2 = value.StockTransferRequisitionDetail) === null || _value$StockTransferR2 === void 0 ? void 0 : _value$StockTransferR2.map(function (r) {
                        var _params$row10;
                        return (params === null || params === void 0 || (_params$row10 = params.row) === null || _params$row10 === void 0 ? void 0 : _params$row10.id) === (r === null || r === void 0 ? void 0 : r.id) ? _objectSpread(_objectSpread({}, r), {}, {
                            DestinationLocations: transformedData
                        }) : r;
                    });
                    if (onChange)
                        onChange(null, newRows);
                };
                var getDestinationLocation = function (apiParams) { return __awaiter(_this, void 0, void 0, function () {
                    var _res$data2, res, data;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getAvailableQtyByWarehouse(apiParams)];
                            case 1:
                                res = _a.sent();
                                data = res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.map(function (r) {
                                    var _params$row$Destinati, _params$row$Destinati2;
                                    return (_params$row$Destinati = (_params$row$Destinati2 = params.row.DestinationLocations) === null || _params$row$Destinati2 === void 0 ? void 0 : _params$row$Destinati2.find(function (it) { return it.id === r.id; })) !== null && _params$row$Destinati !== void 0 ? _params$row$Destinati : r;
                                });
                                return [2 /*return*/, {
                                        data: data,
                                        success: true
                                    }];
                        }
                    });
                }); };
                var onDestinationLocationClick = function () {
                    var _params$row11, _params$row12, _params$row13;
                    var modalProps = {
                        onSubmit: handleLocationDetailSubmit,
                        apiRequest: {
                            TenantId: UserOrganization,
                            ProductId: params === null || params === void 0 || (_params$row11 = params.row) === null || _params$row11 === void 0 ? void 0 : _params$row11.ProductId,
                            WarehouseId: warehouseId
                        },
                        apiCall: getDestinationLocation,
                        apiKey: 'getAvailableQty',
                        columns: destinationLocation,
                        title: t('Destination location'),
                        data: params === null || params === void 0 || (_params$row12 = params.row) === null || _params$row12 === void 0 ? void 0 : _params$row12.DestinationLocations,
                        rowData: params.row,
                        selectedRows: (params === null || params === void 0 || (_params$row13 = params.row) === null || _params$row13 === void 0 || (_params$row13 = _params$row13.DestinationLocations) === null || _params$row13 === void 0 ? void 0 : _params$row13.map(function (e) { return e === null || e === void 0 ? void 0 : e.id; })) || []
                    };
                    setModalProps(modalProps);
                    setSourceLocationPopup(true);
                };
                return /*#__PURE__*/ React.createElement(SourceLocationCell, _extends({}, params, {
                    onButtonClick: onDestinationLocationClick,
                    rowData: params === null || params === void 0 || (_params$row14 = params.row) === null || _params$row14 === void 0 ? void 0 : _params$row14.DestinationLocations,
                    formData: value
                }));
            }
        }, {
            field: 'Remarks',
            headerName: 'Remarks',
            editable: true,
            flex: 1,
            headerAlign: 'left'
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        dataGridHeader: "Part details",
        dataGridProps: {
            checkboxSelection: true,
            onCellEditStop: handleCellEditStop,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            sx: {
                borderRadius: 2
            },
            isCellEditable: function (params) {
                var row = params.row;
                if (!row.ProductId && params.field !== 'Product') {
                    return false;
                }
                return params.id !== 'total';
            },
            disableColumnMenu: true
        },
        rows: (value === null || value === void 0 ? void 0 : value.StockTransferRequisitionDetail) || [],
        error: error === null || error === void 0 ? void 0 : error['StockTransferRequisitionDetail'],
        onChange: onChange,
        validationModel: {
            RequestedQuantity: function (value, row) {
                if (value > row.AvailableQuantity) {
                    return 'QTY should not be more than available QTY';
                }
            },
            SourceLocations: function (value, row) {
                if (!warehouseId) {
                    return 'Select Warehouse';
                }
            }
        }
    }), /*#__PURE__*/ React.createElement(MuiPopup, {
        id: "part-location-popup",
        variant: "h1",
        openPopup: Boolean(modalProps),
        onClose: function () {
            setModalProps(undefined);
        },
        closeIcon: true,
        title: modalProps === null || modalProps === void 0 ? void 0 : modalProps.title,
        subTitleStyle: {
            marginTop: "10px",
            color: "#8593A3"
        },
        backdropEnable: true,
        padding: "15px 0px 0px 15px",
        containerStyle: {
            paddingTop: 0,
            paddingX: "16px"
        }
    }, modalProps && /*#__PURE__*/ React.createElement(MultiSelectPopUp, _extends({}, modalProps, {
        onClose: function () { return setModalProps(undefined); }
    }))));
}
